import React from "react";

import Accordion from "./Accordion";
import MoreCompetences from "./MoreCompetences";

import { BackgroundColor } from "./StyledComponents/BackgroundStyle.style";
import BackgroundImg from "./asset/pictures/tropical_junglee.jpg";

const Competences = () => {
  return (
    <>
      {/* <div className="glitch">
        <div className="glitch__item"></div>
        <div className="glitch__item"></div>
      </div> */}
      <BackgroundColor backgroundImg={BackgroundImg}>
        <Accordion
          title="COMPETENCES - COMPETENCES - COMPETENCES - COMPETENCES -
                  COMPETENCES - COMPETENCES - COMPETENCES - COMPETENCES"
          directionOfAnimation="translateLeft"
        >
          <MoreCompetences />
        </Accordion>
      </BackgroundColor>
    </>
  );
};

export default Competences;
